export default __webpack_public_path__ + "static/media/wwf_main_large.1c6daa51.jpg";